import React from 'react';
import {
  compareAccreditationLevels,
  accreditationLevelLabel,
  resolveLiveAccreditationLevel,
  resolveRegisteredAccreditationLevel,
} from '../utils/accreditationLevel';

/**
 * Tick if the live/awarded tier matches signup; arrow up/down if staff changed it.
 */
const AccreditationLevelDeltaMark = ({
  school,
  current,
  registered,
  className = '',
}) => {
  const live = current || resolveLiveAccreditationLevel(school);
  const signed = registered || resolveRegisteredAccreditationLevel(school);
  const delta = compareAccreditationLevels(live, signed);
  const signedLabel = accreditationLevelLabel(signed, { long: true });

  const meta =
    delta === 'match'
      ? { mark: '✓', title: `Matches registered level (${signedLabel})`, modifier: 'match' }
      : delta === 'up'
        ? { mark: '↑', title: `Up from registered ${signedLabel}`, modifier: 'up' }
        : { mark: '↓', title: `Down from registered ${signedLabel}`, modifier: 'down' };

  return (
    <span
      className={`accreditation-level-delta accreditation-level-delta--${meta.modifier}${className ? ` ${className}` : ''}`}
      title={meta.title}
      aria-label={meta.title}
    >
      {meta.mark}
    </span>
  );
};

export default AccreditationLevelDeltaMark;
